'use client'
import { usePageTracking } from 'composition/tracking/usePageTracking'

const PageViewTracking = () => {
  usePageTracking()

  return null
}

export default PageViewTracking
